import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SetStateAction } from "react";
import { FiChevronDown, FiUser } from "react-icons/fi";
import Profile from "./profile/profile";
import { HooksProps } from "../../types/common";
import { ProfileConfigProps } from "./profile/domain/types";
import { HeaderMenuBottonProps } from "./profile/domain/types";
import { useState } from "react";

const UserMenu = ({ hooks, profileConfig, logout, headerMenuButtons, showProfileMenu, setShowProfileMenu, children }: { hooks: HooksProps; profileConfig: ProfileConfigProps, logout: () => Promise<void>, headerMenuButtons?: HeaderMenuBottonProps[], showProfileMenu: boolean, setShowProfileMenu: React.Dispatch<SetStateAction<boolean>>; children?: React.ReactNode }) => {
  const { useApp } = hooks;
  const { user } = useApp();
  const [showLicenseDetails, setShowLicenseDetails] = useState(false);

  const onLicenseClick = () => {
    const licenseBtn = headerMenuButtons?.find((btn) => btn.title === 'Licence Agreement');
    licenseBtn?.action();
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className="flex items-center cursor-pointer">
            {!user?.avatar && (
              <div className="gradient p-1 rounded-full">
                <div className="w-7 h-7 grid place-content-center bg-dark rounded-full">
                  <FiUser size={20} />
                </div>
              </div>
            )}
            {user?.avatar && (
              <div className="gradient p-1 rounded-full">
                <Avatar className="w-7 h-7">
                  <AvatarImage
                    src={`data:image/jpeg;base64,${user?.avatar}`}
                    alt="@shadcn"
                  />
                  <AvatarFallback></AvatarFallback>
                </Avatar>
              </div>
            )}
            <div className="flex items-center gap-2 font-bold whitespace-nowrap">
              <span className="capitalize">{user?.firstName}</span>
              <span className="capitalize">{user?.lastName}</span>
            </div>
            <div className="mt-1">
              <FiChevronDown />
            </div>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-48 bg-dark mt-3 border-slate">
          <DropdownMenuGroup>
            <DropdownMenuItem
              className="cursor-pointer hover:bg-slate"
              onClick={() => setShowProfileMenu(true)}
            >
              Profile
            </DropdownMenuItem>
            {headerMenuButtons && headerMenuButtons.map((button, index) => {
              return (
                <DropdownMenuItem
                  key={index}
                  className="cursor-pointer hover:bg-slate"
                  onClick={() => button.action()}
                >
                  {button.title}
                </DropdownMenuItem>
              );
            })}
            <DropdownMenuItem
              onClick={logout}
              className="cursor-pointer hover:bg-slate"
            >
              Logout
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
      {!showLicenseDetails &&
        <Profile
          closeMenu={() => setShowProfileMenu(false)}
          onLicenseClick={onLicenseClick}
          showProfileMenu={showProfileMenu}
          profileConfig={profileConfig}
          hooks={hooks}
        >
          {children}
        </Profile>
      }
    </>
  );
};

export default UserMenu;
